/* unplugin-vue-components disabled */import script from "./RoleSkillCard.vue?vue&type=script&setup=true&lang=js"
export * from "./RoleSkillCard.vue?vue&type=script&setup=true&lang=js"

import "./RoleSkillCard.vue?vue&type=style&index=0&id=4e4fd4b4&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e4fd4b4"]])

export default __exports__